import Vue from 'vue'
import Router from 'vue-router'
import store from '@/vuex/store'
import { Dialog } from 'vant';

import Home from '@/pages/index'
import GoodsList from '@/pages/goods/index'
import Goods from '@/pages/goods/detail'
import User from '@/pages/user/index'
import Login from '@/pages/login/index'
import NoteLogin from '@/pages/login/notelogin'
import Register from '@/pages/register/index'
import BackPass from '@/pages/backpass/index'
import AffirmOrder from '@/pages/affirmorder/index'
import OrderSucceed from '@/pages/affirmorder/ordersucceed'
import Cart from '@/pages/user/cart/cart'
import Read from '@/pages/user/read/read'
import Readed from '@/pages/user/read/readed'
import Puhui from '@/pages/user/do/puhui'
import Nodo from '@/pages/user/do/nodo'
import Phdetail from '@/pages/user/do/detail'
import Zhinan from '@/pages/user/do/zhinan'
import Pingjia from '@/pages/user/do/pingjia'
import Collect from '@/pages/user/collect/collect'
import MyMoney from '@/pages/user/mymoney/mymoney'
import Money from '@/pages/user/mymoney/money'
import MyNews from '@/pages/user/mynews/mynews'
import News from '@/pages/user/mynews/news'
import MyOrder from '@/pages/user/myorder/myorder'
import AllOrder from '@/pages/user/myorder/allorder'
import FinishOrder from '@/pages/user/myorder/finishorder'
import PayOrder from '@/pages/user/myorder/payorder'
import SendOrder from '@/pages/user/myorder/sendorder'
import TakeOrder from '@/pages/user/myorder/takeorder'
import Order from '@/pages/user/myorder/order'
import MySite from '@/pages/user/mysite/mysite'
import AddSite from '@/pages/user/mysite/addsite'
import AmendSite from '@/pages/user/mysite/amendsite'
import Personal from '@/pages/user/personal/index'
import Password from '@/pages/user/personal/password'
import Phone from '@/pages/user/personal/phone'
import History from '@/pages/user/history/index'
import Help from '@/pages/user/help/index'
import Logistics from '@/pages/user/myorder/logistics'
import Count from '@/pages/activity/count'
import SignIn from '@/pages/activity/signin'
import Invite from '@/pages/activity/invite'
import Adventures from '@/pages/activity/adventures'
import HaveFun from '@/pages/activity/havefun'
import BrandGoods from '@/pages/goods/brandgoods'
import BindMobile from '@/pages/user/personal/mobile'
Vue.use(Router)
var root = process.env.API_ROOT
const router = new Router({
  mode: 'history',
  routes: [
    {path:'*',redirect:'/'},
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '博思软件',
        keepAlive: false
      }
    },
    {
      path: '/brandgoods',
      name: 'BrandGoods',
      component: BrandGoods,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/havefun',
      name: 'HaveFun',
      component: HaveFun,
      meta: {
        keepAlive: false,
        title: '积分活动',
      }
    },
    {
      path: '/adventures',
      name: 'Adventures',
      component: Adventures,
      meta: {
        title: '积分活动',
        keepAlive: false
      }
    },
    {
      path: '/user/invite',
      name: 'Invite',
      component: Invite,
      meta: {
        keepAlive: true,
        title: '邀请好友',
      }
    },
    {
      path: '/signin',
      name: 'SignIn',
      component: SignIn,
      meta: {
        keepAlive: true,
        title: '签到',
      }
    },
    {
      path: '/count',
      name: 'Count',
      component: Count,
      meta: {
        title: '积分活动',
        keepAlive: true
      }
    },
    {
      path: '/user/history',
      name: 'History',
      component: History,
      meta: {
        keepAlive: true,
        title: '浏览历史',
      }
    },
    {
      path: '/user/personal',
      name: 'Personal',
      component: Personal,
      meta: {
        keepAlive: false,
        title: '会员信息',
      }
    },
    {
      path: '/user/personal/phone',
      name: 'Phone',
      component: Phone,
      meta: {
        keepAlive: false,
        title: '修改手机号',
      }
    },
    {
      path: '/user/personal/password',
      name: 'Password',
      component: Password,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/user/mynews/news',
      name: 'News',
      component: News,
      meta: {
        keepAlive: false,
        title: '我的消息',
      }
    },
    {
      path: '/user/cart',
      name: 'Cart',
      component: Cart,
      meta: {
        keepAlive: false,
        title: '兑换袋',
      }
    },
    {
      path: '/user/mynews',
      name: 'MyNews',
      component: MyNews,
      // redirect: '/user/mynews/dealnews',
      meta: {
        keepAlive: true
      },
      /*children: [
        {
          name:'DealNews',
          path: 'dealnews',
          component: DealNews,
          meta: {
            keepAlive: true
          }
        },
        {
          name:'MessageNews',
          path: 'messagenews',
          component: MessageNews,
          meta: {
            keepAlive: true
          }
        },
        {
          name:'InteractNews',
          path: 'interactnews',
          component: InteractNews,
          meta: {
            keepAlive: true
          }
        }
      ]*/
    },
    {
      path: '/user/collect',
      name: 'Collect',
      component: Collect,
      meta: {
        keepAlive: false,
        title: '我的收藏',
      }
    },
    {
      path: '/user/myorder/logistics',
      name: 'Logistics',
      component: Logistics,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/user/read',
      name: 'Read',
      component: Read,
      meta: {
        title: '博思软件',
        keepAlive: true
      }
    },
    {
      path: '/user/readed',
      name: 'Readed',
      component: Readed,
      meta: {
        title: '博思软件',
        keepAlive: true
      }
    },
    {
      path: '/user/puhui',
      name: 'Puhui',
      component: Puhui,
      meta: {
        title: '积分制度',
        keepAlive: false
      }
    },
    {
      path: '/user/detail',
      name: 'Phdetail',
      component: Phdetail,
      meta: {
        title: '积分制度',
        keepAlive: false
      }
    },
    {
      path: '/user/zhinan',
      name: 'Zhinan',
      component:Zhinan,
      meta: {
        title: '积分指南',
        keepAlive: false
      }
    },
    {
      path: '/user/pingjia',
      name: 'Pingjia',
      component:Pingjia,
      meta: {
        title: '会员评家',
        keepAlive: false
      }
    },
    {
      path: '/user/nodo',
      name: 'Nodo',
      component:Nodo,
      meta: {
        title: '积分公益',
        keepAlive: false
      }
    },
    {
      path: '/user/myorder',
      name: 'MyOrder',
      component: MyOrder,
      redirect: '/user/myorder/allorder',
      meta: {
        title: '我的订单',
        keepAlive: false
      },
      children: [
        {
          name:'AllOrder',
          path: 'allorder',
          component: AllOrder,
          meta: {
            title: '我的订单',
            keepAlive: false
          },
        },
        {
          name:'PayOrder',
          path: 'payorder',
          component: PayOrder,
          meta: {
            title: '我的订单',
            keepAlive: false
          },
        },
        {
          name:'SendOrder',
          path: 'sendorder',
          component: SendOrder,
          meta: {
            title: '我的订单',
            keepAlive: false
          },
        },
        {
          name:'TakeOrder',
          path: 'takeorder',
          component: TakeOrder,
          meta: {
            title: '我的订单',
            keepAlive: false
          },
        },
        {
          name:'FinishOrder',
          path: 'finishorder',
          component: FinishOrder,
          meta: {
            title: '我的订单',
            keepAlive: false
          },
        }

      ]
    },
    {
      path: '/user/myorder/order',
      name: 'Order',
      component: Order,
      meta: {
        title: '订单详情',
        keepAlive: false
      }
    },
    {
      path: '/user/mymoney',
      name: 'MyMoney',
      component: MyMoney,
      meta: {
        title: '积分明细',
        keepAlive: true
      }
    },
    {
      path: '/user/mymoney/money',
      name: 'Money',
      component: Money,
      meta: {
        title: '积分明细',
        keepAlive: false
      }
    },
    {
      path: '/user/mysite',
      name: 'MySite',
      component: MySite,
      meta: {
        title: '我的地址',
        keepAlive: false
      }
    },
    {
      path: '/user/help',
      name: 'Help',
      component: Help,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/user/mysite/addsite',
      name: 'AddSite',
      component: AddSite,
      meta: {
        title: '添加收货地址',
        keepAlive: false
      }
    },
    {
      path: '/user/mysite/amendsite',
      name: 'AmendSite',
      component: AmendSite,
      meta: {
        title: '修改收货地址',
        keepAlive: false
      }
    },
    {
      path: '/ordersucceed',
      name: 'OrderSucceed',
      component: OrderSucceed,
      meta: {
        title: '订单成功',
        keepAlive: false
      }
    },
    {
      path: '/affirmOrder',
      name: 'AffirmOrder',
      component: AffirmOrder,
      meta: {
        title: '确认订单',
        keepAlive: false
      }
    },
    {
      path: '/backpass',
      name: 'BackPass',
      component: BackPass,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: '登录',
        keepAlive: true
      }
    },
    {
      path: '/notelogin',
      name: 'NoteLogin',
      component: NoteLogin,
      meta: {
        title: '登录',
        keepAlive: true
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: {
        title: '注册',
        keepAlive: true
      }
    },
    {
      path: '/goodsList',
      name: 'GoodsList',
      component: GoodsList,
      meta: {
        title: '商品列表',
        keepAlive: false
      }
    },
    {
      path: '/goodsList/goods',
      name: 'Goods',
      component: Goods,
      meta: {
        title: '商品详情',
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/user',
      name: 'User',
      component: User,
      meta: {
        title: '积分兑换',
        keepAlive: false 
      }
    },
    {
      path: '/user/personal/mobile',
      name: 'BindMobile',
      component: BindMobile,
      meta: {
        title: '绑定手机号',
        keepAlive: false 
      }
    },
  ]

})

export default router;
// const VueRouterPush = Router.prototype.push
// Router.prototype.push = function push(to) {
//   return VueRouterPush.call(this. to).catch(err => err)
// }
router.beforeEach((to, from, next) => {
  const nextRoute = [
    'User',
    'History',
    'AffirmOrder',
    'OrderSucceed',
    'MySite',
    'AddSite',
    'AmendSite',
    'MyMoney',
    'Money',
    'MyOrder',
    'Order',
    'AllOrder',
    'PayOrder',
    'SendOrder',
    'TakeOrder',
    'FinishOrder',
    'Collect',
    'MyNews',
    'News',
    'Cart',
    'Password',
    'Personal',
    'Logistics',
    'SignIn',
    'Invite',
    'Pingjia',
    'Nodo',
    'BindMobile'
  ];
  const getUser = ['Home']
  //global.isLogin = false;
  let isUser = localStorage.getItem("BLHuser");   //用户token
  // console.log(isUser)
  // 未登录状态；当路由到nextRoute指定页时，跳转至login
  if (nextRoute.indexOf(to.name) >= 0) {
    $.ajax({
      type: 'POST',
      url: root+'/WebApi/Login/Index/select_login',
      data: {token:isUser},
      success: function(res){
        if(JSON.parse(res).errCode == '0000'){
          next()
        } else if(JSON.parse(res).errCode == '0002') {
          Dialog.confirm({
            title: '提示 ',
            message: JSON.parse(res).desc
          }).then(() => {
            var logintype = localStorage.getItem("BLHlogintype")
            if(logintype == 1){
              router.push({ name: 'Login' })
            }
            else if(logintype == 3){
              router.push({ name: 'Login' })
            }
          }).catch(() => {
          });
        } else{
            Dialog.confirm({
              title: '提示 ',
              message: '您还未登录是否去登录？'
            }).then(() => {
              var logintype = localStorage.getItem("BLHlogintype")
              if(logintype == 1){
                router.push({ name: 'Login' })
              }
              else if(logintype == 3){
                router.push({ name: 'Login' })
              }
              
            }).catch(() => {
            });
        }
      },
      error: function (err) {

      }
    });
  }else{
    next()
  }

});



// WEBPACK FOOTER //
// ./src/router/index.js